<context-menu class="context-menu-ng context-menu-quick-charts">
  <ng-template contextMenuItem (execute)="onEdit()">
    <span><span class="context-link-name">Edit Filter</span></span>
  </ng-template>

  <ng-template contextMenuItem [divider]="true"></ng-template>

  <ng-template contextMenuItem [enabled]="field !== null" (execute)="onSetDiscrete()">
    <span [class.selected]="field?.variable?.type === variableDiscrete">
      <span class="indicator"></span>
      <span class="context-link-name">Discrete</span>
    </span>
  </ng-template>

  <ng-template
    contextMenuItem
    [enabled]="field !== null && field?.filterType === FilterType.Discrete"
    (execute)="onSetContinuous()"
  >
    <span [class.selected]="field?.variable?.type === variableContinuous">
      <span class="indicator"></span>
      <span class="context-link-name">Continuous</span>
    </span>
  </ng-template>

  <ng-template contextMenuItem [divider]="true"></ng-template>

  <ng-template contextMenuItem [enabled]="field !== null" (execute)="onRemove()">
    <span><span class="context-link-name">Remove</span></span>
  </ng-template>
</context-menu>


